import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { HttpRequestService } from './HttpRequestService';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class ServicesService {

  constructor(private http: HttpClient, private httpRequestService: HttpRequestService) { }

  private readonly triidyServiceUrl = `${environment.apiTriidyUrl}`;
  private readonly triidyServiceUrlRest = `${environment.apiTriidyUrlRest}/api`;
  private readonly pedidosEnviaUrl = `${environment.apiEnviaUrl}`;
  private emitChangeSource = new Subject<any>();
  changeEmitted$ = this.emitChangeSource.asObservable();

  getDataLogin(string_connection: any): Observable<any[]> {
    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      string_connection,
      token,
    });
    return this.http
      .get<any[]>(`${this.triidyServiceUrl}/Redireccionar`, {
        params,
      })
      .pipe(
        map((respuesta) => {
          return respuesta;
        })
      );
  }

  subscribeNewsletter(nombre: any, email: any): Observable<any> {

    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      email,
      nombre,
      token,
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/RegistroNewsletter`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  emitChange(change: any) {
    this.emitChangeSource.next(change);
  }
}


@Injectable({
  providedIn: 'root'
})
export class CookieManagerService {

  constructor(private cookieService: CookieService) { }

  checkModalShown(): boolean {
    return this.cookieService.get('modalShown') === 'true';
  }

  setModalShown() {
    this.cookieService.set('modalShown', 'true', 365); // Se establece la cookie por 365 días
  }
}
